export const shouldLog = () => {
  let logging = localStorage.getItem("logging");
  return logging && logging !== "false";
};
